// extracted by mini-css-extract-plugin
export default {"wrapper":"common-overview_wrapper__iXe0C","loading":"common-overview_loading__N7GGw"};